// extracted by mini-css-extract-plugin
export default {"partnerStyles":"Partners_partnerStyles__-L8tr","partners":"Partners_partners__wLk5v","overlay":"Partners_overlay__-Eruu"};